"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onDateInput = exports.onDateInputBlur = exports.onDateInputFocus = exports.onDateInputMouseCLick = exports.FormatDateInput = void 0;
var FormatDateInput = function (event) {
    /* eslint-disable no-useless-escape */
    var regNum = new RegExp('^([0-9])$');
    var readerId = document.getElementById(event.target.id + "-readeralert");
    var invalidDay = function (val) {
        if (val.length === 1 && parseInt(val, 10) > 3) {
            return true;
        }
        if (val.length > 1 && parseInt(val, 10) > 31) {
            return true;
        }
        return false;
    };
    var invalidMonth = function (val) {
        if (val.length === 1 && parseInt(val, 10) > 1) {
            return true;
        }
        if (val.length > 1 && parseInt(val, 10) > 12) {
            return true;
        }
        return false;
    };
    var invalidYear = function (val) {
        if (parseInt(val, 10) > 2) {
            return true;
        }
        return false;
    };
    if (event) {
        var curInput = event.target.value;
        var cursorPoint = event.target.selectionStart;
        if (regNum.test(event.key)) {
            // Day editing
            // case: first field entry by tab, only 1 number exists
            if (cursorPoint === 1 && curInput.length === 1) {
                if (invalidDay(curInput)) {
                    event.target.value = "0" + curInput + "/MM/YYYY";
                    event.target.setSelectionRange(3, 5);
                    if (readerId) {
                        readerId.innerHTML = 'We have added the leading 0 for your day';
                    }
                }
                else {
                    event.target.value = curInput + "/MM/YYYY";
                    event.target.setSelectionRange(1, 1);
                }
                return;
            }
            // Day editing
            // case: first field entry by click, only 1 number for day entered
            if (cursorPoint === 1 && curInput.charAt(cursorPoint) === '/') {
                if (invalidDay(curInput.slice(0, 1))) {
                    event.target.value = "0" + curInput;
                    event.target.setSelectionRange(3, 5);
                    if (readerId) {
                        readerId.innerHTML = 'We have added the leading 0 for your day';
                    }
                }
                return;
            }
            // Day editing
            // case: entering second number in day field
            // case: entering first number in day field with a number already existing in day field
            if (cursorPoint === 2 || (cursorPoint === 1 && regNum.test(curInput.charAt(cursorPoint)))) {
                // check if the day is valid. autocomplete month if not
                if (curInput.slice(0, 2) === '00') {
                    event.target.setSelectionRange(0, 2);
                }
                else if (invalidDay(curInput.slice(0, 2))) {
                    event.target.value = "0" + curInput.slice(0, 1) + "/0" + curInput.slice(1, 2) + "/" + curInput.slice(6);
                    event.target.setSelectionRange(6, 10);
                    if (readerId) {
                        readerId.innerHTML = 'We have added the leading 0 for your day and month. You are now editing the year';
                    }
                }
                else {
                    if (curInput.slice(3, 5).includes('/')) {
                        event.target.setSelectionRange(3, 3);
                    }
                    else {
                        event.target.setSelectionRange(3, 5);
                    }
                }
                return;
            }
            // month editing
            // case: entered by focus, click or updating date field. first entry into month field
            if (cursorPoint === 4 && curInput.charAt(cursorPoint) === '/') {
                // check if the month is valid, autocomplete if it isn't
                if (invalidMonth(curInput.slice(3, 4))) {
                    event.target.value = curInput.slice(0, 2) + "/0" + curInput.slice(3);
                    event.target.setSelectionRange(6, 10);
                    if (readerId) {
                        readerId.innerHTML = 'We have added the leading 0 for your month';
                    }
                }
                return;
            }
            // month editing
            // case: entering second number in month field
            // case: entering first number in month field with a number already existing in month field
            if (cursorPoint === 5 || (cursorPoint === 4 && regNum.test(curInput.charAt(cursorPoint)))) {
                if (curInput.slice(3, 5) === '00') {
                    event.target.setSelectionRange(3, 5);
                    if (readerId) {
                        readerId.innerHTML = '00 is an invalid month, please re-enter the month';
                    }
                }
                // check if the month is valid, autocomplete if it isn't
                else if (invalidMonth(curInput.slice(3, 5))) {
                    // check if year is valid. Add 19 if not
                    if (invalidYear(curInput.slice(4, 5))) {
                        event.target.value = curInput.slice(0, 3) + "0" + curInput.slice(3, 4) + "/19" + curInput.slice(4, 5);
                        if (readerId) {
                            readerId.innerHTML = 'We have added the leading 19 for your year';
                        }
                        return;
                    }
                    event.target.value = curInput.slice(0, 2) + "/0" + curInput.slice(3, 4) + "/" + curInput.slice(4, 5);
                }
                else {
                    event.target.setSelectionRange(6, 10);
                }
                return;
            }
            // year editing
            // case: entering year, first digit being entered
            if (cursorPoint === 7 && !regNum.test(curInput.charAt(cursorPoint))) {
                // check if the year is valid
                if (invalidYear((curInput.slice(6, 7)))) {
                    event.target.value = curInput.slice(0, 5) + "/19" + curInput.slice(6);
                    if (readerId) {
                        readerId.innerHTML = 'We have added the leading 19 for your year';
                    }
                }
                return;
            }
        }
    }
};
exports.FormatDateInput = FormatDateInput;
// handle cursor positioning and selection, ensuring DD MM and YYYY are selected as a group
var onDateInputMouseCLick = function (event) {
    var curInput = event.target.value;
    var cursorPoint = event.target.selectionStart;
    event.target.value = CheckCompletedSection(event);
    if (curInput.charAt(cursorPoint) === 'D' || curInput.charAt(cursorPoint - 1) === 'D') {
        event.target.setSelectionRange(0, 2);
    }
    else if (curInput.charAt(cursorPoint) === 'M' || curInput.charAt(cursorPoint - 1) === 'M') {
        event.target.setSelectionRange(3, 5);
    }
    else if (curInput.charAt(cursorPoint) === 'Y' || curInput.charAt(cursorPoint - 1) === 'Y') {
        event.target.setSelectionRange(6, 10);
    }
};
exports.onDateInputMouseCLick = onDateInputMouseCLick;
// handle the selected area on focus, either DD MM or YYYY
var onDateInputFocus = function (event) {
    var curInput = event.target.value;
    if (event.target.value.length === 0) {
        event.target.value = 'DD/MM/YYYY';
        event.target.setSelectionRange(0, 2);
        return;
    }
    if (curInput.slice(0, 2).includes('DD')) {
        event.target.setSelectionRange(0, 2);
        return;
    }
    if (curInput.slice(3, 5).includes('MM')) {
        event.target.setSelectionRange(3, 5);
        return;
    }
    if (curInput.slice(6, 10).includes('YYYY')) {
        event.target.setSelectionRange(6, 10);
        return;
    }
};
exports.onDateInputFocus = onDateInputFocus;
var CheckCompletedSection = function (event, onExit) {
    var dayEditing = new RegExp('^[0-9]{1,1}[\/][0-9M]{0,2}[\/][0-9Y]{0,4}$');
    var dayEditingCancelled = new RegExp('^[\/][0-9M]{0,2}[\/][0-9Y]{0,4}$');
    var monthEditing = new RegExp('^[0-9D]{2}[\/][0-9]{1,1}[\/][0-9Y]{0,4}$');
    var monthEditingCancelled = new RegExp('^[0-9D]{2}[\/][\/][0-9Y]{0,4}$');
    var yearEditingCancelled = new RegExp('^[0-9D]{2}[\/][0-9M]{2}[\/]$');
    var curInput = event.target.value;
    if (curInput === 'DD/MM/YYYY' || curInput === 'DD//YYYY' || curInput === '/MM/YYYY' || curInput === 'DD/MM/') {
        if (onExit) {
            return '';
        }
    }
    if (dayEditing.test(curInput)) {
        return "0" + curInput;
    }
    if (dayEditingCancelled.test(curInput)) {
        return "DD" + curInput;
    }
    if (monthEditing.test(curInput)) {
        return event.target.value.slice(0, 3) + "0" + event.target.value.slice(3);
    }
    if (monthEditingCancelled.test(curInput)) {
        return event.target.value.slice(0, 3) + "MM" + event.target.value.slice(3);
    }
    if (yearEditingCancelled.test(curInput)) {
        return event.target.value.slice(0, 6) + "YYYY";
    }
    return curInput;
};
// handle completed date or returning of default text on leaving the field
var onDateInputBlur = function (event) {
    event.target.value = CheckCompletedSection(event, true);
};
exports.onDateInputBlur = onDateInputBlur;
// Only allow number input, handle back slash, handle length max of 10
var onDateInput = function (event) {
    var reg = new RegExp('^([a-zA-Z$-/:-?{-~!\'"^_`@#])$');
    var regDigi = new RegExp('^([0-9])$');
    var curInput = event.target.value;
    var cursorPoint = event.target.selectionStart;
    var selectedText = (cursorPoint !== event.target.selectionEnd);
    var readerId = document.getElementById(event.target.id + "-readeralert");
    if (event) {
        // check if character is a / and allow if a single digit day or month has been entered adding leading 0
        if (event.key === '/') {
            event.preventDefault();
            if (cursorPoint === 1) {
                event.target.value = "0" + curInput;
                event.target.setSelectionRange(3, 5);
            }
            else if (cursorPoint === 4) {
                event.target.value = event.target.value.slice(0, cursorPoint - 1) + "0" + event.target.value.slice(cursorPoint - 1);
                event.target.setSelectionRange(6, 10);
            }
            return;
        }
        // handle letters and special characters
        if (reg.test(event.key)) {
            event.preventDefault();
            return;
        }
        // handle delete.
        if (event.keyCode === 8) {
            // case: slash
            if (!selectedText && curInput.slice(cursorPoint - 1, cursorPoint) === '/') {
                var textToDelete = curInput.slice(cursorPoint - 2, cursorPoint - 1);
                // case: dealing with the delete of a number
                if (regDigi.test(textToDelete)) {
                    curInput = CheckCompletedSection(event, true);
                    event.target.value = curInput.slice(0, cursorPoint - 1) + curInput.slice(cursorPoint - 1);
                    event.target.setSelectionRange(cursorPoint - 1, cursorPoint - 1);
                    if (readerId) {
                        readerId.innerHTML = "/ and " + textToDelete + " have been deleted.";
                    }
                }
                else if (textToDelete === 'D') {
                    curInput = CheckCompletedSection(event);
                    event.target.value = curInput.slice(cursorPoint - 1);
                    event.target.setSelectionRange(0, 0);
                    if (readerId) {
                        readerId.innerHTML = 'DD has been deleted';
                    }
                }
                else if (textToDelete === 'M') {
                    curInput = CheckCompletedSection(event);
                    event.target.value = curInput.slice(0, 4) + curInput.slice(cursorPoint - 1);
                    event.target.setSelectionRange(3, 4);
                    if (readerId) {
                        readerId.innerHTML = 'MM has been deleted';
                    }
                }
            }
            return;
        }
        // arrowing right, select full DD MM YYYY and ignore /
        if (event.keyCode === 39) {
            if (!regDigi.test(curInput.charAt(cursorPoint)) || selectedText) {
                event.preventDefault();
                event.target.value = CheckCompletedSection(event);
                if (cursorPoint <= 2) {
                    event.target.setSelectionRange(3, 5);
                }
                else if (cursorPoint <= 5) {
                    event.target.setSelectionRange(6, 10);
                }
            }
            return;
        }
        // arrowing left, select full DD MM YYYY and ignore /
        if (event.keyCode === 37) {
            if (!regDigi.test(curInput.charAt(cursorPoint - 1)) || selectedText) {
                event.preventDefault();
                event.target.value = CheckCompletedSection(event);
                if (cursorPoint >= 6) {
                    event.target.setSelectionRange(3, 5);
                }
                else if (cursorPoint >= 3) {
                    event.target.setSelectionRange(0, 2);
                }
            }
            return;
        }
        // trying to add 3 numbers to DD MM or 5 for YYYY
        if (event.target.value.length >= 10 && (cursorPoint > 6 || !selectedText)) {
            if (cursorPoint < 3) {
                event.target.setSelectionRange(0, 2);
                event.preventDefault();
                if (readerId) {
                    readerId.innerHTML = 'Day has already been entered. we have selected the day value for you to begin entering a new day. Arrow left to enter the month';
                }
            }
            else if (cursorPoint < 6) {
                event.target.setSelectionRange(3, 5);
                event.preventDefault();
                if (readerId) {
                    readerId.innerHTML = 'Month has already been entered. we have selected the month value for you to begin entering a new month. Arrow left or right to enter the day or year';
                }
            }
            else {
                event.target.setSelectionRange(6, 10);
                event.preventDefault();
                if (readerId) {
                    readerId.innerHTML = 'Year has already been entered. we have selected the year value for you to begin entering a new year. Arrow left to enter the month';
                }
            }
            return;
        }
        // edge case. entering in part of a year then trying to add 3 numbers into DD or MM
        if (cursorPoint < 5 && curInput.lastIndexOf('/') === 5 && !selectedText) {
            if (cursorPoint < 3) {
                event.target.setSelectionRange(0, 2);
                event.preventDefault();
                if (readerId) {
                    readerId.innerHTML = 'Day has already been entered. we have selected the day value for you to begin entering a new day. Arrow left to enter the month';
                }
            }
            else if (cursorPoint < 6) {
                event.target.setSelectionRange(3, 5);
                event.preventDefault();
                if (readerId) {
                    readerId.innerHTML = 'Month has already been entered. we have selected the month value for you to begin entering a new month. Arrow left or right to enter the day or year';
                }
            }
        }
    }
};
exports.onDateInput = onDateInput;
